import { CompleteQuery, CompleteRequirement, CompleteCriteria, CompleteCondition } from '../types';

type QueryLayer = CompleteQuery | CompleteCriteria | CompleteRequirement | CompleteCondition;

export const isQueryOrCriteriaLayer = (
  layer: QueryLayer,
): layer is CompleteQuery | CompleteCriteria => layer && 'searchQueries' in layer;

export const isRequirementLayer = (layer: QueryLayer): layer is CompleteRequirement =>
  layer && 'searchCombo' in layer;

export const isConditionLayer = (layer: QueryLayer): layer is CompleteCondition =>
  layer && 'comparatorType' in layer && 'field' in layer && 'fieldType' in layer;

/**
 *
 * util to traverse a provided search query to check if a certain condition exists with a provided cb.
 */
export const conditionExistsInQuery = (
  layer: QueryLayer | QueryLayer[],
  cb: (condition: CompleteCondition) => boolean,
): boolean => {
  if (Array.isArray(layer)) return layer.some((leafLayer) => conditionExistsInQuery(leafLayer, cb));
  if (isQueryOrCriteriaLayer(layer)) return conditionExistsInQuery(layer.searchQueries, cb);
  if (isRequirementLayer(layer)) return conditionExistsInQuery(layer.searchCombo.searchQueries, cb);
  if (isConditionLayer(layer)) return cb(layer);
  else return false;
};
